import { laneNeeds } from '../world/Generator.js';

/**
 * Consejos en las primeras partidas: cuando se acerca algo que exige un gesto (saltar, agacharse,
 * cambiar de carril, girar), muestra qué hacer. Cada tipo de consejo sale como mucho dos veces por
 * partida y solo durante las primeras RUNS partidas del dispositivo.
 */
const RUNS = 3;
const LEAD = 1.3; // segundos de antelación
const MAX_PER_TYPE = 2;

const TEXTS = {
  low: 'Desliza ↑ para saltar el tronco',
  high: 'Desliza ↓ para pasar bajo la zarza',
  pit: 'Desliza ↑ para saltar el foso',
  wall: 'Desliza ← o → para esquivar',
  turnLeft: 'Desliza ← para girar',
  turnRight: 'Desliza → para girar',
  tee: 'Desliza ← o → para elegir camino',
};

// Con el control por cámara.
const CAMERA_TEXTS = {
  low: '¡Salta el tronco!',
  high: 'Agáchate (flexiona las rodillas) para pasar bajo la zarza',
  pit: '¡Salta el foso!',
  wall: 'Levanta un brazo para cambiar de carril',
  turnLeft: 'Levanta el brazo izquierdo para girar',
  turnRight: 'Levanta el brazo derecho para girar',
  tee: 'Levanta un brazo para elegir camino',
};

export class Tutorial {
  constructor() {
    this.active = false;
  }

  /** Al empezar una partida. runs = partidas jugadas antes (con este control); camera = control por cámara. */
  start(runs, camera = false) {
    this.active = runs < RUNS;
    this.texts = camera ? CAMERA_TEXTS : TEXTS;
    this.shown = {};
    this.seen = new WeakSet(); // filas y tramos ya avisados
  }

  /** Devuelve el texto del consejo que toca mostrar ahora, o null. */
  update(p) {
    if (!this.active || p.state !== 'running') return null;
    const seg = p.segment;
    const ahead = p.speed * LEAD;

    if ((seg.turn || seg.tee) && p.toCorner < ahead + 4 && !p.queuedTurn && !this.seen.has(seg)) {
      this.seen.add(seg);
      return this.#emit(seg.tee ? 'tee' : seg.turn < 0 ? 'turnLeft' : 'turnRight');
    }
    for (const row of seg.rows) {
      const dist = row.s - p.s;
      if (dist < 0) continue;
      if (dist > ahead) break;
      if (this.seen.has(row)) return null;
      this.seen.add(row);
      const need = laneNeeds(row.pieces)[p.lane];
      return need === 'free' ? null : this.#emit(need);
    }
    return null;
  }

  #emit(type) {
    const n = this.shown[type] ?? 0;
    if (n >= MAX_PER_TYPE) return null;
    this.shown[type] = n + 1;
    return this.texts[type];
  }
}
